
import { useAppContext } from '@/context/app'
import { goToAddFailurePage } from '@/pages/communal/machine/failures/add/Main'
import { Machine } from '@/services/model/machine'
import { MachineName } from '@/components/machine'
import { useNavigate, useParams } from 'react-router-dom'
import { useCallback, useEffect, useState } from 'react'
import { Spinner } from '@/components/spinner'
import { useMachine } from '@/hooks/useMachine'
import { useCheckDistance } from '@/hooks/useCheckDistance'
import { ErrorBox } from '@/components/error'
import { MainPageLayout } from '@/components/layout/MainLayout'
import { MachinePath } from '../Common'
import { BackButton } from '@/components/layout/NavBar'


export interface SimpleUserGroup {
  id: string
  name: string
}

export const ActivateMachinePage = () => {
  const machineId = useParams().mid
  const { services, session, translates } = useAppContext()
  const [generalError, setGeneralError] = useState(false)
  const [spinner, setSpinner] = useState(false)

  const { machine, error: loadingMachineError } = useMachine(machineId)
  const [distanceError, distanceOk] = useCheckDistance(machine?.params?.deviceData?.lat, machine?.params?.deviceData?.lng)

  const navigate = useNavigate()

  const machineActivate = useCallback(async (): Promise<void> => {
    if (!machine) {
      return
    }

    setGeneralError(false)
    setSpinner(true)

    try {
      const resp = await services.session.fetchWithToken(`/api/communal/machines/byid/${machine.id}/activate`, {
        method: "POST"
      })

      if (!resp.ok) {
        setGeneralError(true)
        return
      }

      navigate(`/communal/machine/${machineId}/session/dashboard`, { replace: true })
    } finally {
      setSpinner(false)
    }
  }, [machine?.id, services.session])

  if (translates === undefined || !machine || !session) {
    return <div className='spinner'></div>
  }

  return <MainPageLayout pageName='machine-hitmap' services={services} translates={translates} session={session}
    path={[...MachinePath({ session, translates, machine }), {
      title: translates.for(`page.communal-machine-activate.title`)
    }]}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>

    <div className="main-content-container">

      <h3>{translates.for('page.communal-machine-activate.title')}</h3>
      <p className='desc'>
        {translates.for('page.communal-machine-activate.description')}
      </p>
      <p className='desc'>
        {translates.for('page.communal-machine-activate.checked_approve')}
      </p>

      {spinner ? <Spinner /> : <div className='btns'>
        {distanceOk === true ? <div>
          <a className='btn btn-next main-btn' onClick={machineActivate}>
            {translates.for('machine.checklist.wizard.activate.approve')}
          </a>

          <a className='btn btn-fail main-red-btn' onClick={() => {
            goToAddFailurePage({
              navigate,
              machineId: machine.id
            })
          }}>
            {translates.for('page.communal-machine-activate.fail')}
          </a>
        </div> : null}

        <ErrorBox errors={{ distanceError, generalError, loadingMachineError }} />
      </div>
      }
    </div>
  </MainPageLayout >
}
